import { jwtDecode } from 'jwt-decode';
import type { Token } from '../@types/Token';
import type { Actions } from '../actions';
import { RCV_ACCESS_TOKEN, ERR_ACCESS_TOKEN as REQUEST_FAILED_AUTH } from '../actions/auth';
import {
  RCV_BRANCH_ADD_ADMIN,
  RCV_BRANCH_REMOVE_ADMIN,
  RCV_BRANCH_REMOVE_ALL_ADMIN,
  REQ_BRANCH_ADD_ADMIN,
  REQ_BRANCH_REMOVE_ADMIN,
  REQ_BRANCH_REMOVE_ALL_ADMIN,
  REQUEST_FAILED as REQUEST_FAILED_ADMIN,
} from '../actions/branch-admin';
import { requestStatus, responseStatus } from '../shared/statuses';

interface BranchAdminState {
  requestStatus: number;
  responseStatus: number;
  belongsToBranches: string[];
  authTime: number;
}

const _initialState: BranchAdminState = {
  requestStatus: requestStatus.WAITING,
  responseStatus: responseStatus.OK,
  belongsToBranches: [],
  authTime: 0,
};

const isString = (str: string | string[]) => typeof str === 'string' || str instanceof String;

const getBranches = (token: Token): string[] => {
  const branches: string | string[] = token['belongs-to-branch'] || [];
  if (isString(branches)) {
    return [branches as unknown as string];
  }
  return branches;
};

const branchAdminReducer = (
  state: BranchAdminState = _initialState,
  action: Actions,
): BranchAdminState => {
  let list = null;

  switch (action.type) {
    case RCV_ACCESS_TOKEN: {
      const token = jwtDecode<Token>(action.response);
      if (token.auth_time > state.authTime) {
        const branches = getBranches(token);
        return { ...state, authTime: token.auth_time, belongsToBranches: branches };
      }
      return { ...state };
    }
    case REQ_BRANCH_ADD_ADMIN:
      return {
        ...state,
        requestStatus: requestStatus.FETCHING,
        responseStatus: responseStatus.PENDING,
      };
    case RCV_BRANCH_ADD_ADMIN:
      list = state.belongsToBranches.slice();
      list.push(action.response);
      return {
        ...state,
        belongsToBranches: list,
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.OK,
      };
    case REQ_BRANCH_REMOVE_ADMIN:
      return {
        ...state,
        requestStatus: requestStatus.REMOVING,
        responseStatus: responseStatus.PENDING,
      };
    case RCV_BRANCH_REMOVE_ADMIN: {
      list = state.belongsToBranches.slice();
      const index = list.indexOf(action.response);

      if (index >= 0) {
        list.splice(index, 1);
      }

      return {
        ...state,
        belongsToBranches: list,
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.OK,
      };
    }
    case REQ_BRANCH_REMOVE_ALL_ADMIN:
      return {
        ...state,
        requestStatus: requestStatus.REMOVING,
        responseStatus: responseStatus.PENDING,
      };
    case RCV_BRANCH_REMOVE_ALL_ADMIN:
      return {
        ...state,
        belongsToBranches: [],
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.OK,
      };
    case REQUEST_FAILED_AUTH:
      return {
        ...state,
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.FAILED,
      };
    case REQUEST_FAILED_ADMIN:
      return {
        ...state,
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.FAILED,
      };
    default:
      return state;
  }
};

export default branchAdminReducer;
